import React from 'react';

const AnalyticsSVG = () => {
  return (
    <svg
      width="329"
      height="190"
      viewBox="0 0 329 190"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4774 133.742H0.015625V189.032H11.4774V133.742Z"
        fill="#DF76BB"
      />
      <path
        d="M99.9808 111.105H88.519V189.039H99.9808V111.105Z"
        fill="#DF76BB"
      />
      <path
        d="M56.6854 115.984H45.2236V189.032H56.6854V115.984Z"
        fill="#DF76BB"
      />
      <path
        d="M21.354 106.6V189.032H33.8564V106.6H21.354ZM22.3946 188.363V107.422H32.823V188.363H22.3946Z"
        fill="#8DD473"
      />
      <path
        d="M66.7783 84.8887V189.032H79.2809V84.8887H66.7783ZM67.8191 188.188V85.9298H78.2475V188.188H67.8191Z"
        fill="#8DD473"
      />
      <path
        d="M237.864 15.6035H220.77V137.206H237.864V15.6035Z"
        fill="#DF76BB"
      />
      <path
        d="M299.509 28.2715H282.415V137.206H299.509V28.2715Z"
        fill="#DF76BB"
      />
      <path
        d="M252.529 1.16602V136.857H271.286V1.16602H252.529ZM254.09 135.757V2.5146H269.733V135.75H254.09V135.757Z"
        fill="#8DD473"
      />
      <path
        d="M252.529 1.16602V136.857H271.286V1.16602H252.529ZM254.09 135.757V2.5146H269.733V135.75H254.09V135.757Z"
        fill="#8DD473"
      />
      <path
        d="M310.243 2.60742V138.298H329V2.60742H310.243ZM311.803 137.198V3.95599H327.447V137.191H311.803V137.198Z"
        fill="#8DD473"
      />
      <g filter="url(#filter0_dd_1216_68177)">
        <path
          d="M248.881 51.8438H83.2558C80.7399 51.8438 78.7002 53.8844 78.7002 56.4015V169.348C78.7002 171.865 80.7399 173.905 83.2558 173.905H248.881C251.396 173.905 253.436 171.865 253.436 169.348V56.4015C253.436 53.8844 251.396 51.8438 248.881 51.8438Z"
          fill="white"
        />
      </g>
      <path
        d="M248.881 51.8438H83.2558C80.7379 51.8438 78.7002 53.8824 78.7002 56.4015V69.9H253.436V56.4015C253.436 53.8824 251.399 51.8438 248.881 51.8438Z"
        fill="#EFA9D6"
      />
      <path
        d="M223.41 63.3186C221.837 63.3186 220.564 62.0444 220.564 60.4718C220.564 58.8992 221.837 57.625 223.41 57.625C224.981 57.625 226.255 58.8992 226.255 60.4718C226.255 62.0444 224.981 63.3186 223.41 63.3186ZM223.41 58.353C222.245 58.353 221.292 59.2995 221.292 60.4718C221.292 61.644 222.237 62.5904 223.41 62.5904C224.582 62.5904 225.527 61.644 225.527 60.4718C225.527 59.2995 224.582 58.353 223.41 58.353Z"
        fill="white"
      />
      <path
        d="M233.523 63.3186C231.952 63.3186 230.677 62.0444 230.677 60.4718C230.677 58.8992 231.952 57.625 233.523 57.625C235.095 57.625 236.369 58.8992 236.369 60.4718C236.369 62.0444 235.095 63.3186 233.523 63.3186ZM233.523 58.353C232.358 58.353 231.406 59.2995 231.406 60.4718C231.406 61.644 232.352 62.5904 233.523 62.5904C234.695 62.5904 235.64 61.644 235.64 60.4718C235.64 59.2995 234.695 58.353 233.523 58.353Z"
        fill="white"
      />
      <path
        d="M243.944 63.3186C242.373 63.3186 241.098 62.0444 241.098 60.4718C241.098 58.8992 242.373 57.625 243.944 57.625C245.516 57.625 246.79 58.8992 246.79 60.4718C246.79 62.0444 245.516 63.3186 243.944 63.3186ZM243.944 58.353C242.779 58.353 241.827 59.2995 241.827 60.4718C241.827 61.644 242.773 62.5904 243.944 62.5904C245.116 62.5904 246.061 61.644 246.061 60.4718C246.061 59.2995 245.116 58.353 243.944 58.353Z"
        fill="white"
      />
      <path
        d="M241.687 76.4551H90.4634C88.4137 76.4551 86.752 78.1176 86.752 80.1682V161.858C86.752 163.909 88.4137 165.571 90.4634 165.571H241.687C243.736 165.571 245.398 163.909 245.398 161.858V80.1682C245.398 78.1176 243.736 76.4551 241.687 76.4551Z"
        fill="white"
      />
      <path
        d="M131.555 157.72C112.067 157.72 96.2603 141.914 96.2603 122.409C96.2603 102.904 112.059 87.0977 131.555 87.0977C131.999 87.0977 131.759 157.714 131.555 157.714V157.72Z"
        fill="#8DD473"
      />
      <path
        d="M169.813 122.415C169.813 102.917 154.015 87.1035 134.518 87.1035C134.292 87.1035 134.241 104.337 134.279 122.561C134.279 122.692 169.805 122.561 169.805 122.415H169.813Z"
        fill="#D1EEC7"
      />
      <path
        d="M135.085 151.847C134.779 151.847 134.615 147.363 134.59 138.393C134.582 135.125 134.582 131.855 134.59 129.401C134.596 126.435 134.726 124.953 134.984 124.953C161 124.902 161.167 125.069 161.328 125.229C161.393 125.295 161.436 125.397 161.436 125.491C161.436 140.024 149.617 151.847 135.092 151.847H135.085ZM135.325 125.673C135.261 128.564 135.333 148.426 135.42 151.113C149.283 150.931 160.535 139.674 160.702 125.804C158.97 125.695 149.494 125.644 135.325 125.673Z"
        fill="#DF76BB"
      />
      <path
        d="M228.611 105.216H180.725C180.522 105.216 180.361 105.056 180.361 104.852C180.361 104.648 180.522 104.488 180.725 104.488H228.611C228.814 104.488 228.974 104.648 228.974 104.852C228.974 105.056 228.814 105.216 228.611 105.216Z"
        fill="#DF76BB"
      />
      <path
        d="M203.802 115.955H180.725C180.522 115.955 180.361 115.794 180.361 115.591C180.361 115.387 180.522 115.227 180.725 115.227H203.802C204.005 115.227 204.166 115.387 204.166 115.591C204.166 115.794 204.005 115.955 203.802 115.955Z"
        fill="#DF76BB"
      />
      <path
        d="M228.539 115.955H207.711C207.508 115.955 207.348 115.794 207.348 115.591C207.348 115.387 207.508 115.227 207.711 115.227H228.539C228.743 115.227 228.904 115.387 228.904 115.591C228.904 115.794 228.743 115.955 228.539 115.955Z"
        fill="#DF76BB"
      />
      <path
        d="M246.297 113.58L225.011 91.6063C224.872 91.4608 224.872 91.2278 225.017 91.0895C225.163 90.9511 225.389 90.9511 225.535 91.0967L246.326 112.553L269.424 90.8711L296.801 112.109C296.961 112.233 296.991 112.458 296.866 112.619C296.743 112.779 296.517 112.808 296.357 112.684L269.475 91.8248L246.303 113.572L246.297 113.58Z"
        fill="#DF76BB"
      />
      <path
        d="M225.274 97.1187C228.458 97.1187 231.038 94.5371 231.038 91.3523C231.038 88.1677 228.458 85.5859 225.274 85.5859C222.091 85.5859 219.511 88.1677 219.511 91.3523C219.511 94.5371 222.091 97.1187 225.274 97.1187Z"
        fill="#D1EEC7"
      />
      <path
        d="M275.204 91.3523C275.204 94.534 272.628 97.1187 269.441 97.1187C266.253 97.1187 263.677 94.5414 263.677 91.3523C263.677 88.1634 266.253 85.5859 269.441 85.5859C272.628 85.5859 275.204 88.1634 275.204 91.3523Z"
        fill="#D1EEC7"
      />
      <path
        d="M252.007 113.334C252.517 110.19 250.383 107.228 247.241 106.718C244.099 106.208 241.138 108.342 240.628 111.486C240.119 114.629 242.252 117.591 245.394 118.102C248.536 118.612 251.496 116.477 252.007 113.334Z"
        fill="#EFA9D6"
      />
      <path
        d="M302.307 113.112C302.696 109.952 300.45 107.074 297.291 106.684C294.131 106.295 291.256 108.542 290.867 111.703C290.477 114.864 292.723 117.742 295.882 118.131C299.042 118.52 301.918 116.273 302.307 113.112Z"
        fill="#EFA9D6"
      />
      <defs>
        <filter
          id="filter0_dd_1216_68177"
          x="72.7002"
          y="45.8438"
          width="186.735"
          height="134.061"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1216_68177"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1216_68177"
            result="effect2_dropShadow_1216_68177"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1216_68177"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default AnalyticsSVG;
